import { Box, Grid, Typography, makeStyles } from "@material-ui/core";

import { SEGMENTS } from "../../services/constants";

const useStyles = makeStyles(() => ({
  grid: {
    "&:not(:last-child)": {
      marginRight: 30,
    },
  },
  box: {
    width: 23,
    height: 6,
    borderRadius: 8,
    marginRight: 6,
  },
}));

const Legend = ({ legend }) => {
  const classes = useStyles();

  return (
    <Grid container className={classes.grid} style={{ width: "auto" }} alignItems="center">
      <Box className={classes.box} style={{ background: legend.color }}></Box>
      <Typography style={{ textTransform: "capitalize" }}>{legend.name}</Typography>
    </Grid>
  );
};

export const Legends = ({ legends = SEGMENTS }) => {
  return (
    <Grid container justifyContent="flex-end" style={{ width: "auto" }}>
      {legends.map((legend, i) => (
        <Legend key={i} legend={legend} />
      ))}
    </Grid>
  );
};
